import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";

import { Provider } from "react-redux";
import { baseName } from "./settings";
import { store } from "./store";

export const pollKey = "POLL_DATE";
const APP_VERSION = process.env.REACT_APP_CURRENT_GIT_SHA;

if (sessionStorage.getItem("APP_VERSION") !== APP_VERSION) {
  const pollNumber = localStorage.getItem(pollKey);
  sessionStorage.clear();
  localStorage.clear();
  if (pollNumber) {
    localStorage.setItem(pollKey, pollNumber);
  }
  sessionStorage.setItem("APP_VERSION", APP_VERSION || ``);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <Router basename={baseName}>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
  /* </React.StrictMode> */
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
